var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vendor-terms-of-service"},[_c('md-card',[_c('md-card-header',[_c('h1',{staticClass:"md-title"},[_vm._v("Terms of Service")])]),_c('md-card-content',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }